import { MenuItem, Tooltip } from "@mui/material";

interface Props {
  disabled: boolean;
  disabledTitle: string;
  onClick?: () => void;
  color?: string;
  children: React.ReactNode;
}

export function ConditionalMenuItem({
  disabled,
  disabledTitle,
  onClick,
  color,
  children,
}: Props) {
  if (disabled) {
    return (
      <Tooltip title={disabledTitle} placement="right">
        <span>
          <MenuItem
            dense
            disabled
            sx={{ fontSize: "0.82rem", pointerEvents: "none" }}
          >
            {children}
          </MenuItem>
        </span>
      </Tooltip>
    );
  }
  return (
    <MenuItem
      dense
      sx={{ fontSize: "0.82rem", ...(color ? { color } : {}) }}
      onClick={onClick}
    >
      {children}
    </MenuItem>
  );
}
